import { createResourceSlice } from '../store/resource/createResourceSlice';
import { ADMINISTRATION_SETTING_RESOURCE } from '../api/resources';

const administrationSettingSlice = createResourceSlice({
    resource: ADMINISTRATION_SETTING_RESOURCE,
    byKey: 'id',
});

export const {
    indexFulfilled,
    showFulfilled,
    storeFulfilled,
    updateFulfilled,
    destroyFulfilled,
    indexAdministrationSetting,
    showAdministrationSetting,
    updateAdministrationSetting,
    storeAdministrationSetting,
} = administrationSettingSlice.actions;

export const {
    selectAdministrationSettingById,
    selectAdministrationSettingLoading,
    selectAdministrationSettingInitialized,
    selectAllAdministrationSettings,
} = administrationSettingSlice.selectors;

export const {
    useAdministrationSetting,
    useAdministrationSettings,
    useAdministrationSettingById,
} = administrationSettingSlice.hooks;

export default administrationSettingSlice.reducer;